import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import itemChange from 'owa-service/lib/factory/itemChange';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
/**
 * Issues a service request to update items categories
 * @param itemContexts item contexts for updating categories
 * @returns a promise which contains UpdateItemResponse
 */
export default function updateItemsCategoriesService(itemContexts) {
    var requestBody = configureRequestBody(itemContexts);
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response.Body.ResponseMessages.Items[0];
    });
}
/**
 * Configure the request body to update category for item
 * @param itemContexts item contexts for updating categories
 * @returns the request body of UpdateItemRequest
 */
function configureRequestBody(itemContexts) {
    var changes = itemContexts.map(function (itemContext) {
        return itemChange({
            Updates: [createSetItemField('Categories', itemContext.newCategoriesCollection)],
            ItemId: itemId({
                Id: itemContext.itemId.Id,
                ChangeKey: itemContext.itemId.ChangeKey,
            }),
        });
    });
    return updateItemRequest({
        ItemChanges: changes,
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}
//# sourceMappingURL=updateItemsCategoriesService.js.map